import React from 'react';
import { Box } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { ExportButton, type ExportConfig } from '../../export';
import { canExportExplorerCsv } from './explorerCsvAccess';
import { EXPLORER_EXPORT_BUTTON_SX, EXPLORER_FILTER_CONTROL_HEIGHT } from './utils';

interface ExplorerExportButtonProps {
    /** Omit when the current view has no export yet; clicking then shows "Próximamente". */
    config?: ExportConfig | undefined;
    tooltip?: string;
    iconOnly?: boolean;
}

/** Explorer filter-row export; render it as the row's last item so it sits at the far right. */
const ExplorerExportButton: React.FC<ExplorerExportButtonProps> = ({ config, tooltip, iconOnly }) => {
    const { user, company } = useAuth();

    if (!canExportExplorerCsv(user?.companyId ?? company?._id)) {
        return null;
    }

    return (
        <Box
            component="span"
            sx={{
                display: 'inline-flex',
                height: EXPLORER_FILTER_CONTROL_HEIGHT,
                alignItems: iconOnly ? 'center' : 'stretch',
            }}
        >
            <ExportButton
                config={config}
                variant="text"
                iconOnly={iconOnly}
                sx={iconOnly ? { flexShrink: 0 } : EXPLORER_EXPORT_BUTTON_SX}
                {...(tooltip ? { tooltip } : {})}
            />
        </Box>
    );
};

export default ExplorerExportButton;
